import { render, staticRenderFns } from "./FluxoDeCaixa.vue?vue&type=template&id=5b817ec2"
import script from "./FluxoDeCaixa.vue?vue&type=script&lang=js"
export * from "./FluxoDeCaixa.vue?vue&type=script&lang=js"
import style0 from "./FluxoDeCaixa.vue?vue&type=style&index=0&id=5b817ec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports